import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './facilityCustomViewActions';
import * as types from './facilityCustomViewActionType';
import * as services from './facilityCustomViewServices';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';

// Get Facility Custom View Fields Saga
function* getFacilityCustomViewFieldsSaga(action) {
    try {
        const response = yield call(services.getFacilityCustomViewFieldsAPI, action.payload);
        if (response?.success) {
            yield put(actions.getFacilityCustomViewFieldsSuccess(response.values || {}));
        } else {
            yield put(actions.getFacilityCustomViewFieldsFailure('No data found'));
        }
    } catch (error) {
        console.error('Get Facility Custom View Fields Fetch Error:', error);
        yield put(actions.getFacilityCustomViewFieldsFailure(error.message || 'Failed to fetch facility custom view fields'));
    }
}

// Save Facility Custom View Saga
function* saveFacilityCustomViewSaga(action) {
    try {
        const response = yield call(services.saveFacilityCustomViewAPI, action.payload);

        if (response?.success) {
            yield put(actions.saveFacilityCustomViewSuccess(response));

            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Successfully Saved Facility Custom View.'
            });
        } else {
            yield put(actions.saveFacilityCustomViewFailure(response?.errorMessage || 'Save failed'));

            SweetAlert.error({
                title: 'Oops',
                text: response?.errorMessage || 'Failed to save Facility Custom View.'
            });
        }
    } catch (error) {
        yield put(actions.saveFacilityCustomViewFailure(error.message || 'Save failed'));

        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to save Facility Custom View.'
        });
    }
}

function* fetchSiteCustomViewsSaga() {
  try {
    const response = yield call(services.getAllFacilityCustomViewsByUserId);

    if (response?.success) {
      yield put(actions.fetchSiteCustomViewsSuccess(response.values || []));
    } else {
      yield put(
        actions.fetchSiteCustomViewsFailure(
          response?.errorMessage || "Failed to fetch facility custom views",
        ),
      );
    }
  } catch (error) {
    yield put(
      actions.fetchSiteCustomViewsFailure(
        error.response?.data?.errorMessage ||
          "Failed to fetch facility custom views",
      ),
    );
  }
}

function* toggleSiteCustomViewSaga(action) {
  try {
    const response = yield call(services.toggleFacilityCustomView, action.payload);
    if (response?.success) {
      yield put(actions.toggleSiteCustomViewSuccess(response));
      yield put(actions.fetchSiteCustomViewsRequest());
      SweetAlert.success({ title: "Success!", text: response.resultMessage || "Status updated successfully." });
    } else {
      yield put(actions.toggleSiteCustomViewFailure(response?.errorMessage || "Failed to update status."));
      SweetAlert.error({ title: "Error!", text: response?.errorMessage || "Failed to update status." });
    }
  } catch (error) {
    yield put(actions.toggleSiteCustomViewFailure(error.message));
    SweetAlert.error({ title: "Error!", text: "Failed to update status." });
  }
}

function* deleteSiteCustomViewSaga(action) {
  try {
    const response = yield call(services.deleteFacilityCustomView, action.payload);
    if (response?.success) {
      yield put(actions.deleteSiteCustomViewSuccess(response));
      yield put(actions.fetchSiteCustomViewsRequest());
      SweetAlert.success({ title: "Success!", text: response.resultMessage || "Custom View deleted successfully." });
    } else {
      yield put(actions.deleteSiteCustomViewFailure(response?.errorMessage || "Failed to delete custom view."));
      SweetAlert.error({ title: "Error!", text: response?.errorMessage || "Failed to delete custom view." });
    }
  } catch (error) {
    yield put(actions.deleteSiteCustomViewFailure(error.message));
    SweetAlert.error({ title: "Error!", text: "Failed to delete custom view." });
  }
}

function* fetchSiteCustomViewDataSaga(action) {
  try {
    const response = yield call(services.getFacilityCustomViewData, action.payload);
    if (response?.success) {
      yield put(actions.fetchSiteCustomViewDataSuccess(response.values || response.value));
    } else {
      yield put(actions.fetchSiteCustomViewDataFailure(response?.errorMessage || "Failed to fetch facility data."));
    }
  } catch (error) {
    yield put(actions.fetchSiteCustomViewDataFailure(error.message));
  }
}

// Fetch Site Custom View Share Dropdown Saga
function* fetchSiteCustomViewShareDropdownSaga(action) {
  try {
    const response = yield call(services.fetchSiteCustomViewShareDropdownAPI, action.payload);
    if (response?.success || response?.values) {
      const dropdownData = response.values?.dropdownListModel || [];
      const sharedListData = response.values?.sharedViewList || [];

      yield put(actions.fetchSiteCustomViewShareDropdownSuccess({
        dropdownData,
        sharedListData
      }));
    } else {
      yield put(actions.fetchSiteCustomViewShareDropdownFailure(response?.errorMessage || 'No data found'));
    }
  } catch (error) {
    yield put(actions.fetchSiteCustomViewShareDropdownFailure(error.message || 'Failed to fetch data'));
  }
}

// Save Shared Site Custom View Saga
function* saveSharedSiteCustomViewSaga(action) {
  try {
    const response = yield call(services.saveSharedSiteCustomViewAPI, action.payload);
    if (response?.success) {
      yield put(actions.saveSharedSiteCustomViewSuccess(response));
      // Refresh the shared list after successful save
      yield put(actions.fetchSiteCustomViewShareDropdownRequest({
        ViewId: action.payload.ViewId,
        LoginUserId: action.payload.LoginUserId
      }));
    } else {
      yield put(actions.saveSharedSiteCustomViewFailure(response?.errorMessage || 'Failed to save shared custom view'));
    }
  } catch (error) {
    yield put(actions.saveSharedSiteCustomViewFailure(error.message || 'Failed to save shared custom view'));
  }
}

export default function* facilityCustomViewSaga() {
    yield takeEvery(types.GET_FACILITY_CUSTOM_VIEW_FIELDS_REQUEST, getFacilityCustomViewFieldsSaga);
    yield takeEvery(types.SAVE_FACILITY_CUSTOM_VIEW_REQUEST, saveFacilityCustomViewSaga);
     yield takeEvery(
    types.FETCH_SITE_CUSTOM_VIEWS_REQUEST,
    fetchSiteCustomViewsSaga,
  );
  yield takeEvery(types.TOGGLE_SITE_CUSTOM_VIEW_REQUEST, toggleSiteCustomViewSaga);
  yield takeEvery(types.DELETE_SITE_CUSTOM_VIEW_REQUEST, deleteSiteCustomViewSaga);
  yield takeEvery(types.FETCH_SITE_CUSTOM_VIEW_DATA_REQUEST, fetchSiteCustomViewDataSaga);
  yield takeEvery(types.FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST, fetchSiteCustomViewShareDropdownSaga);
  yield takeEvery(types.SAVE_SHARED_SITE_CUSTOM_VIEW_REQUEST, saveSharedSiteCustomViewSaga);
}
